const DEFAULT_CONFIG = {
  level: 'all'
};
export const getConfig = key => {
  var _window, _window$BC_LOGGER;
  return ((_window = window) === null || _window === void 0 ? void 0 : (_window$BC_LOGGER = _window.BC_LOGGER) === null || _window$BC_LOGGER === void 0 ? void 0 : _window$BC_LOGGER[key]) || DEFAULT_CONFIG[key] || null;
};
export const configure = config => {
  var _window$BC_LOGGER2;
  const packageName = ((_window$BC_LOGGER2 = window.BC_LOGGER) === null || _window$BC_LOGGER2 === void 0 ? void 0 : _window$BC_LOGGER2.packageName) || (config === null || config === void 0 ? void 0 : config.packageName) || process.env.REACT_APP_PACKAGE_NAME;
  window.BC_LOGGER = {
    ...(window.BC_LOGGER || {}),
    ...config,
    packageName
  };
};